import {SET_SPREAD_RECAP_OPTIONS} from '../actionTypes'

const fetchOptionsFromLocalStore = (key) => {
    let options = {}
    try {
        const localStoreString = localStorage.getItem('spread-recap-options')
        if (localStoreString?.length) {
            options = JSON.parse(localStoreString)
        }

    } catch  {
        options = {
        }
    }
    return options
}

const saveOptionsToLocalStore = (key, options) => {
    try {
        const data = JSON.stringify(options)
        localStorage.setItem(key, data)

    } catch  {
    }
}

const LS_KEY = 'spread-recap-options'

const initialState = fetchOptionsFromLocalStore(LS_KEY)


export default (state=initialState,  action) => {
    switch(action.type) {
        case SET_SPREAD_RECAP_OPTIONS:    
            if (action.options) {
                saveOptionsToLocalStore(LS_KEY, action.options)
                return action.options
            }
            return state
        default:
            return state
     }
}
